// components/schedule/ScheduleDialog/MemberSelection.tsx

import React from 'react';
import {
  Button, Box, Chip, Typography, Grid
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { MemberSelectionProps } from './types';
import { ScheduleMember } from '../../../types/schedule';
import { OtherScheduleMember } from '../../../types/otherSchedule';

export const MemberSelection: React.FC<MemberSelectionProps> = ({
  scheduleType,
  members,
  currentMembers,
  onMemberSelect,
  onMemberRemove,
  membersWithOtherSchedules
}) => {
  // 現在選択されているメンバーIDの配列を取得
  // ここで明示的にunion型をキャストして処理
  const selectedMemberIds = (currentMembers as Array<ScheduleMember | OtherScheduleMember>)
    .filter((m: ScheduleMember | OtherScheduleMember) => m.Member_ID)
    .map((m: ScheduleMember | OtherScheduleMember) => m.Member_ID as number);

  return (
    <>

      {/* メンバー選択グリッド */}
      <Typography variant="subtitle2" sx={{ mb: 1 }}>メンバーを選択</Typography>
      <Grid container spacing={1.5}>
        {members
          .sort((a, b) => (a.ID ?? 0) - (b.ID ?? 0))
          .map((member) => {
            const isSelected = selectedMemberIds.includes(member.ID);
            const hasConflict = membersWithOtherSchedules.includes(member.ID);

            return (
              <Grid item xs={6} sm={4} key={`member-${member.ID}`}>
                <Button
                  fullWidth
                  variant={isSelected ? "contained" : "outlined"}
                  color={isSelected ? "success" : hasConflict ? "warning" : "primary"}
                  onClick={() => onMemberSelect(member)}
                  sx={{
                    height: '50px',
                    whiteSpace: 'normal',
                    lineHeight: 1.2,
                    textTransform: 'none',
                    ...(isSelected && {
                      fontWeight: 'bold',
                      boxShadow: 1,
                    }),
                    ...(hasConflict && !isSelected && {
                      borderStyle: 'dashed',
                      borderWidth: 2
                    }),
                  }}
                >
                  <Typography variant="body2">
                    {member.LastName}
                    {hasConflict && !isSelected && (
                      <Box component="span" sx={{ ml: 0.5, color: 'warning.main' }}>!</Box>
                    )}
                  </Typography>
                </Button>
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};